'use client';

import type { PasswordFormValues } from '@eliadmin/core/src/components/dlz/account/password/password-schema';
import { formFields } from '@eliadmin/core/src/components/dlz/forms/form-fields';

/** The DLZ form fields bound to the change-password form. */
export const { TextField, PasswordField, CheckboxField } = formFields<PasswordFormValues>();
